var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultUserAvatar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-circle",
    "data-name": "Icon awesome-user-circle",
    d: "M22,.563a22,22,0,1,0,22,22A22,22,0,0,0,22,.563Zm0,8.516a7.806,7.806,0,1,1-7.806,7.806A7.807,7.807,0,0,1,22,9.079Zm0,30.516a17,17,0,0,1-13-6.05,9.891,9.891,0,0,1,8.738-5.3,2.171,2.171,0,0,1,.63.1A11.745,11.745,0,0,0,22,28.95a11.7,11.7,0,0,0,3.628-.612,2.171,2.171,0,0,1,.63-.1A9.891,9.891,0,0,1,35,33.545,17,17,0,0,1,22,39.595Z",
    transform: "translate(0 -0.563)",
    fill: "#8e8e8e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUserAvatar);
export default __webpack_public_path__ + "static/media/default-user-avatar.f892816e4fb262bc2da545c5428287ac.svg";
export { ForwardRef as ReactComponent };